module.exports = __webpack_public_path__ + "static/media/ghost-rabbit.1450a0d3.svg";